import { render } from "./CheckRecessi.vue?vue&type=template&id=d7ad1554&scoped=true"
import script from "./CheckRecessi.vue?vue&type=script&lang=js"
export * from "./CheckRecessi.vue?vue&type=script&lang=js"

import "./CheckRecessi.vue?vue&type=style&index=0&id=d7ad1554&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7ad1554"]])

export default __exports__